/* import __COLOCATED_TEMPLATE__ from './predicates-editor.hbs'; */
/* RESPONSIBLE TEAM: team-frontend-tech */
/* === ⚠️ THIS FILE CURRENTLY USES DEPRECATED PATTERNS ⚠️ === */
/* === 🔗 For more information visit https://go.inter.com/ember-best-practices 🔗 */
/* === 🚀 Please consider refactoring & removing some of the comments below when working on this file: 🚀 */
/* eslint-disable @intercom/intercom/no-bare-strings */
/* eslint-disable ember/require-computed-property-dependencies */
/* eslint-disable ember/no-classic-classes */
/* eslint-disable ember/no-classic-components */
/* eslint-disable ember/no-jquery */
/* eslint-disable @intercom/intercom/require-empty-tagname */
import $ from 'jquery';
import Component from '@ember/component';
import { schedule } from '@ember/runloop';
import { computed, action } from '@ember/object';
import { equal } from '@ember/object/computed';
import { inject as service } from '@ember/service';
import PredicateGroup from 'predicates/models/predicate-group';
import Predicate from 'predicates/models/predicate';
import { notImplemented } from '@intercom/pulse/lib/computed-properties';
import { USER_ROLE_PREDICATE, VAM_ROLE_PREDICATE } from 'predicates/models/data/roles';
import scrollIntoViewIfNotVisible from 'embercom/lib/scroll-into-view-if-not-visible';
export default Component.extend({
  mode: 'default',
  store: service(),
  intl: service(),
  predicateGroup: null,
  requiresUserPredicate: false,
  isVamMode: equal('mode', 'vam'),
  attributeListOverride: null,
  attributeGroupList: notImplemented('predicates-editor: You must pass an attributeGroupList property'),
  get userSwitcherItems() {
    return [{
      text: this.intl.t('users-and-companies.predicates-editor.users'),
      value: 'user'
    }, {
      text: this.intl.t('users-and-companies.predicates-editor.leads'),
      value: 'lead'
    }];
  },
  get logicalSwitcherItems() {
    return [{
      text: this.intl.t('users-and-companies.predicates-editor.match-all'),
      value: 'and'
    }, {
      text: this.intl.t('users-and-companies.predicates-editor.match-any'),
      value: 'or'
    }];
  },
  init() {
    this._super(...arguments);
    this.initPredicates();
  },
  didReceiveAttrs() {
    this._super(...arguments);
    if (this.havePredicatesChanged) {
      this.onClose();
      this.initPredicates();
    }
  },
  initPredicates() {
    let predicates = this.predicates.serialize();
    if (this.requiresUserPredicate && !this.get('predicates.length')) {
      let userPredicate = this.isVamMode ? VAM_ROLE_PREDICATE : USER_ROLE_PREDICATE;
      predicates.pushObject(userPredicate);
    }
    this.setPredicateGroup(predicates);
    this.set('lastPredicates', this.predicates.serialize());
    this.set('totalNumberOfFilters', this._getTotalNumberOfFilters());
  },
  havePredicatesChanged: computed('lastPredicates.[]', 'predicates.[]', function () {
    return !_.isEqual(this.lastPredicates, this.predicates.serialize());
  }),
  setPredicateGroup(predicates) {
    let predicateGroup = this.store.createFragment('predicates/predicate-group', {
      predicates: PredicateGroup.convertRawPredicates(this.store, predicates),
      attributeListOverride: this.attributeListOverride
    });
    if (predicateGroup.predicates.any(p => p.isLogicalType) && predicateGroup.predicates.any(p => p.isEditable)) {
      predicateGroup.removeEmptyLogicalPredicates();
    }
    predicateGroup.initializeTopLevelLogicalWrapper();
    this.set('predicateGroup', predicateGroup);
  },
  publicAPI: computed('predicateGroup.editablePredicates.[]', 'totalNumberOfFilters', function () {
    return {
      predicates: this.get('predicateGroup.editablePredicates'),
      totalNumberOfFilters: this.totalNumberOfFilters,
      addPredicate: this.addPredicate
    };
  }),
  _getTotalNumberOfFilters() {
    let totalNumberOfFilters = 0;
    for (let predicate of Predicate.walkPredicates(this.get('predicateGroup.basePredicates'))) {
      if (predicate.isEditable) {
        totalNumberOfFilters++;
      }
    }
    return totalNumberOfFilters;
  },
  _fireUpdate: action(function (meta) {
    this.set('totalNumberOfFilters', this._getTotalNumberOfFilters());
    this.set('lastPredicates', this.get('predicateGroup.predicates').serialize());
    let newPredicatesArray = PredicateGroup.createPredicatesArray(this.store, this.get('predicateGroup.predicates').serialize(), this.attributeListOverride);
    this.onUpdate(newPredicatesArray, meta);
  }),
  addPredicate: action(function (attribute, eventType) {
    let {
      identifier,
      type
    } = attribute;
    this.set('newlyAddedPredicate', this.predicateGroup.editablePredicates.length);
    let context = Object.assign({}, this.predicateContext, {
      mode: this.mode
    });
    this.predicateGroup.add({
      attribute: identifier,
      type
    }, {
      context
    });
    this._fireUpdate({
      action: 'added'
    });
    schedule('afterRender', () => {
      scrollIntoViewIfNotVisible($('.filter-block__container:last', this.element).get(0));
    });
  }),
  updatePredicate: action(function (predicate, updatedPredicate) {
    predicate.setProperties(updatedPredicate);
    this._fireUpdate({
      action: 'edited'
    });
  }),
  removePredicate: action(function (predicate) {
    this.predicateGroup.remove(predicate);
    this._fireUpdate({
      action: 'deleted'
    });
    this.predicateDeleted();
  }),
  switchLogicalMode: action(function (mode) {
    this.predicateGroup.switchLogicalMode(mode);
    this._fireUpdate({
      action: 'edited'
    });
  }),
  switchUserType: action(function (userType) {
    this.predicateGroup.switchUserType(userType);
    this._fireUpdate({
      action: 'edited'
    });
  }),
  onClose: action(function () {
    this.set('newlyAddedPredicate', null);
    if (this.onEditorClose) {
      this.onEditorClose();
    }
  }),
  predicateDeleted: action(function () {
    if (this.onDelete) {
      this.onDelete();
    }
  }),
  predicateOpen: action(function (predicate) {
    if (this.onPredicateOpen) {
      this.onPredicateOpen(predicate);
    }
  })
});